<template>
  <div>
    <!-- {{series}}
    {{chart_option}} -->
    <apexchart ref="ch_wsf_action" type="bar" height="350" :options="chart_option" :series="series"></apexchart>
  </div>
</template>

<!-- https://apexcharts.com/docs/options/datalabels/ -->
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  watch : {
    series() {
      if(this.$refs.ch_wsf_action) {
        this.$refs.ch_wsf_action.refresh()
        console.log("ch_wsf_action chart refreshed")
      }
    }
  },
  components: { apexchart: VueApexCharts },
  props : ['series', 'categories'],
  data: () => {
    return {
      // series: [
      //   { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
      //   { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
      //   { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
      //   { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
      // ],
    }
  },
  // components: { apexchart: VueApexCharts },
  computed : {
    chart_option: function() {
      return {
        dataLabels: {
          enabled: false,
          enabledOnSeries: undefined,
          formatter: function (val, opts) {
              return val
          },
          textAnchor: 'middle', distributed: false,
          offsetX: 0,
          offsetY: 0,
          style: { fontSize: '10px', fontFamily: 'Helvetica, Arial, sans-serif', fontWeight: 'bold', colors: undefined },
        },
        chart: { type: 'bar', height: 350, stacked: true, toolbar: { show: false }, zoom: { enabled: false } },
        responsive: [{
          breakpoint: 480,
          options: { legend: { position: 'bottom', offsetX: -10, offsetY: 0 } }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
              maxItems: 100,
              hideOverflowingLabels: false,
            }
          }
        },
        xaxis: {
          type: 'date',
          categories: this.categories || []
        },
        legend: { position: 'top', offsetY: 40 },
        fill: { opacity: 1 }
      }
    }
  },
  methods: {

  },
  created() { console.log('stacked chart.vue', 'created')},
  destroyed() { console.log('stacked chart.vue', 'destroyed'); },
  mounted() { console.log('stacked chart.vue', 'mounted')}
}
</script>
